// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  OfferingPackageCoachAboutCategoryFragmentDoc,
  OfferingPackageCoachAboutCoachFragmentDoc,
} from './OfferingPackageCoachAbout.generated';
import { PackageReviewsCategoryFragmentDoc } from './PackageReviews.generated';
import {
  CoachOfferingsCoachingFocusFragmentDoc,
  CoachOfferingsCoachFragmentDoc,
  CoachOfferingsOfferingPackageFragmentDoc,
} from '../../coach/__generated-gql-types__/CoachOfferings.generated';
import { IntroVideoCoachFragmentDoc } from '../../coach/__generated-gql-types__/IntroVideo.generated';
import { ReviewSliderCoachFragmentDoc } from '../../coach/__generated-gql-types__/ReviewSlider.generated';
import { AllCoachReviewsModalCoachFragmentDoc } from '../../coach/modals/__generated-gql-types__/AllCoachReviewsModal.generated';
import { MessageModalCoachFragmentDoc } from '../../coach/modals/MessageModal/__generated-gql-types__/index.generated';
import { OfferingPackageCoachMessagePromptCoachFragmentDoc } from './OfferingPackageCoachMessagePrompt.generated';
import { OfferingPackageImageOfferingPackageFragmentDoc } from './OfferingPackageImage.generated';
import { OfferingPackageBannerOfferingPackageFragmentDoc } from './OfferingPackageBanner.generated';
import {
  OfferingPackagePricingInfoOfferingPackageFragmentDoc,
  OfferingPackagePricingInfoOpportunityCoachFragmentDoc,
} from './OfferingPackagePricingInfo.generated';
import { OfferingPackageBottomCtaOfferingPackageFragmentDoc } from './OfferingPackageBottomCTA.generated';
import {
  OfferingPackageCardOfferingPackageFragmentDoc,
  OfferingPackageCardCoachFragmentDoc,
} from './OfferingPackageCard.generated';
import { SelectAPackageSizeModalOfferingPackagePriceFragmentDoc } from './SelectAPackageSizeModal.generated';
import { OfferingPackagesOfferingPackageFragmentDoc } from '../../search/__generated-gql-types__/OfferingPackages.generated';
import { VerticalCoachCardCoachFragmentDoc } from '../../category/__generated-gql-types__/VerticalCoachCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OfferingPackagePageOfferingPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  name: string;
  description: string;
  imageLink?: string | null;
  deliveryFormat?: Types.CoachingDeliveryFormat | null;
  coachingDescription?: string | null;
  deliverables?: Array<string> | null;
  isUniversalPackage: boolean;
  version: number;
  visibility: Types.PackageVisibility;
  slug?: string | null;
  subTitle?: string | null;
  coachingFocusList?: Array<{
    __typename?: 'CoachingFocus';
    id: string;
    name: string;
  }> | null;
  category?: {
    __typename?: 'Category';
    id: string;
    slug: string;
    goal: Types.GoalName;
    name: string;
    averageReviewRate: number;
    outcomes?: Array<
      | {
          __typename?: 'CareerOutcomeSummary';
          number: number;
          companies: Array<{
            __typename?: 'Company';
            id?: string | null;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'SchoolOutcomeSummary';
          number: number;
          schools: Array<{
            __typename?: 'School';
            id: string;
            name: string;
            logoLink?: string | null;
          }>;
        }
      | {
          __typename?: 'TestOutcomeSummary';
          scoreRange?: string | null;
          number: number;
          category: { __typename?: 'Category'; id: string; name: string };
        }
    > | null;
  } | null;
  packageTerm?: {
    __typename?: 'PackageTerm';
    refundPolicy: Types.RefundPolicy;
    additionalInformation?: string | null;
  } | null;
  coach: {
    __typename?: 'Coach';
    id: string;
    visibility: Types.CoachVisibility;
    slug: string;
    reviewTotal: number;
    averageReviewRate: number;
    professionalCoach: boolean;
    openToInternational: boolean;
    createdAt: number;
    newExperience?: boolean | null;
    lelandPlusContributor: boolean;
    hourlyRate?: number | null;
    tier: Types.SkuTier;
    averageKnowledgeReviewRate: number;
    averageValueReviewRate: number;
    averageResponsivenessReviewRate: number;
    averageSupportivenessReviewRate: number;
    couldScheduleIntro?: boolean | null;
    everHadCoachingSessionWithCoach?: boolean | null;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      headline?: string | null;
      qualifications?: string | null;
      testScore?: number | null;
      displayTestScore?: boolean | null;
      experienceLevel?: number | null;
      customersCoached?: number | null;
      id: string;
      category: {
        __typename?: 'Category';
        id: string;
        name: string;
        slug: string;
        goal: Types.GoalName;
        subCategoryTitle?: string | null;
        subCategoryList?: Array<{
          __typename?: 'SubCategory';
          id: string;
          name: string;
        }> | null;
      };
      coachingFocusList?: Array<{
        __typename?: 'CoachingFocus';
        id: string;
        name: string;
        slug: string;
      }> | null;
    }> | null;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      blockedByCoach: boolean;
      newExperience: boolean;
      paidTimeInMinute?: number | null;
      review?: { __typename?: 'Review'; id: string } | null;
      customerSubscription?: {
        __typename?: 'CustomerSubscription';
        id: string;
        sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
      } | null;
    } | null;
    introVideo?: {
      __typename?: 'VideoLink';
      duration: string;
      thumbnailLink: string;
      youtubeId: string;
    } | null;
    educationExperiences?: Array<{
      __typename?: 'Education';
      isFeatured?: boolean | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
    }> | null;
    schoolAdmissionInfoList?: Array<{
      __typename?: 'SchoolAdmissionInfo';
      status?: Types.SchoolAdmissionStatus | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
    }> | null;
    professionalExperiences?: Array<{
      __typename?: 'ProfessionalExperience';
      isFeatured?: boolean | null;
      company: {
        __typename?: 'Company';
        id?: string | null;
        name: string;
        domain?: string | null;
        logoLink?: string | null;
      };
      endAt?: { __typename?: 'MonthYear'; year: number } | null;
    }> | null;
    companiesAdmitted?: Array<{
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    }> | null;
    coachingTimeSummary?: {
      __typename?: 'CoachingTimeSummary';
      availableTime: number;
      hasUnlimitedPackage: boolean;
      cycles?: Array<{
        __typename?: 'SubscriptionCycle';
        timeInMinute: number;
        start?: number | null;
        end?: number | null;
      }> | null;
    } | null;
    mostRecentOrder?: {
      __typename?: 'Order';
      id: string;
      hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
    } | null;
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
      defaultAvailability?: {
        __typename?: 'DefaultAvailability';
        totalInMinute: number;
      } | null;
    } | null;
  };
  subCategories?: Array<{ __typename?: 'SubCategory'; id: string }> | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    tier?: Types.SkuTier | null;
    description?: string | null;
    numberPurchased: number;
    freeLelandPlusPeriod?: {
      __typename?: 'TimePeriod';
      amount: number;
      unit: Types.TimeUnit;
    } | null;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
};

export type OfferingPackagePageCoachPackageFragment = {
  __typename?: 'OfferingPackage';
  id: string;
  status: Types.PackageStatus;
  slug?: string | null;
  name: string;
  subTitle?: string | null;
  isUniversalPackage: boolean;
  imageLink?: string | null;
  prices?: Array<{
    __typename?: 'OfferingPackagePrice';
    sku?: string | null;
    price: number;
    packageCoachingTime?: {
      __typename?: 'PackageCoachingTime';
      exactTimeInMinute?: number | null;
      estimate?: {
        __typename?: 'IntRange';
        start?: number | null;
        end?: number | null;
      } | null;
    } | null;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
  coach: { __typename?: 'Coach'; id: string; slug: string };
};

export type OfferingPackagePageOfferingPackagePriceFragment = {
  __typename?: 'OfferingPackagePrice';
  tier?: Types.SkuTier | null;
  sku?: string | null;
  price: number;
  description?: string | null;
  numberPurchased: number;
  packageCoachingTime?: {
    __typename?: 'PackageCoachingTime';
    exactTimeInMinute?: number | null;
    estimate?: {
      __typename?: 'IntRange';
      start?: number | null;
      end?: number | null;
    } | null;
  } | null;
};

export type OfferingPackagePageOpportunityCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  tier: Types.SkuTier;
  bio?: string | null;
  hourlyRate?: number | null;
  reviewTotal: number;
  averageReviewRate: number;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  categoryInformationList?: Array<{
    __typename?: 'CategoryInformation';
    headline?: string | null;
    category: {
      __typename?: 'Category';
      id: string;
      goal: Types.GoalName;
      sortRank?: number | null;
      slug: string;
    };
  }> | null;
  educationExperiences?: Array<{
    __typename?: 'Education';
    admissionCommittee: boolean;
    isFeatured?: boolean | null;
    school: {
      __typename?: 'School';
      id: string;
      name: string;
      logoLink?: string | null;
    };
  }> | null;
  professionalExperiences?: Array<{
    __typename?: 'ProfessionalExperience';
    experienceType?: Types.ExperienceType | null;
    isFeatured?: boolean | null;
    company: {
      __typename?: 'Company';
      id?: string | null;
      name: string;
      domain?: string | null;
      logoLink?: string | null;
    };
    endAt?: { __typename?: 'MonthYear'; year: number } | null;
  }> | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
};

export type OfferingPackagePageCreateOrderMutationVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  packageOrder: Types.PackageOrderInput;
  numberOfCharges: Types.Scalars['Int']['input'];
  tier?: Types.InputMaybe<Types.SkuTier>;
}>;

export type OfferingPackagePageCreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: { __typename?: 'Order'; id: string };
};

export type OfferingPackagePageGetRelationshipQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
}>;

export type OfferingPackagePageGetRelationshipQuery = {
  __typename?: 'Query';
  coach?: {
    __typename?: 'Coach';
    id: string;
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
    } | null;
  } | null;
};

export type OfferingPackagePageGetHourlyOrderQueryVariables = Types.Exact<{
  id: Types.Scalars['OrderUrn']['input'];
}>;

export type OfferingPackagePageGetHourlyOrderQuery = {
  __typename?: 'Query';
  order?: {
    __typename?: 'Order';
    id: string;
    hourlyOrder?: { __typename?: 'HourlyOrder'; timeInMinute: number } | null;
  } | null;
};

export type OfferingPackagePageSearchPackagesQueryVariables = Types.Exact<{
  keyword?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categoryUrn: Types.Scalars['CategoryUrn']['input'];
  subCategoryUrns?: Types.InputMaybe<
    | Array<Types.Scalars['SubCategoryUrn']['input']>
    | Types.Scalars['SubCategoryUrn']['input']
  >;
  coachingFocusListFilter?: Types.InputMaybe<
    | Array<Types.Scalars['CoachingFocusUrn']['input']>
    | Types.Scalars['CoachingFocusUrn']['input']
  >;
  priceFilter?: Types.InputMaybe<Types.IntRangeInput>;
  start: Types.Scalars['Int']['input'];
  count: Types.Scalars['Int']['input'];
  idsToExclude?: Types.InputMaybe<
    | Array<Types.Scalars['PackageUrn']['input']>
    | Types.Scalars['PackageUrn']['input']
  >;
}>;

export type OfferingPackagePageSearchPackagesQuery = {
  __typename?: 'Query';
  searchPackages: {
    __typename?: 'PackageSearchResponse';
    total: number;
    results: Array<{
      __typename?: 'OfferingPackage';
      id: string;
      slug?: string | null;
      name: string;
      subTitle?: string | null;
      isUniversalPackage: boolean;
      imageLink?: string | null;
      prices?: Array<{
        __typename?: 'OfferingPackagePrice';
        sku?: string | null;
        price: number;
        packageCoachingTime?: {
          __typename?: 'PackageCoachingTime';
          exactTimeInMinute?: number | null;
          estimate?: {
            __typename?: 'IntRange';
            start?: number | null;
            end?: number | null;
          } | null;
        } | null;
      }> | null;
      category?: { __typename?: 'Category'; id: string; slug: string } | null;
      coach: { __typename?: 'Coach'; id: string; slug: string };
    }>;
  };
};

export type OfferingPackagePageGetCoachQueryVariables = Types.Exact<{
  id: Types.Scalars['CoachUrn']['input'];
}>;

export type OfferingPackagePageGetCoachQuery = {
  __typename?: 'Query';
  coach?: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    tier: Types.SkuTier;
    bio?: string | null;
    hourlyRate?: number | null;
    reviewTotal: number;
    averageReviewRate: number;
    user: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      pictureLink?: string | null;
    };
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      headline?: string | null;
      category: {
        __typename?: 'Category';
        id: string;
        goal: Types.GoalName;
        sortRank?: number | null;
        slug: string;
      };
    }> | null;
    educationExperiences?: Array<{
      __typename?: 'Education';
      admissionCommittee: boolean;
      isFeatured?: boolean | null;
      school: {
        __typename?: 'School';
        id: string;
        name: string;
        logoLink?: string | null;
      };
    }> | null;
    professionalExperiences?: Array<{
      __typename?: 'ProfessionalExperience';
      experienceType?: Types.ExperienceType | null;
      isFeatured?: boolean | null;
      company: {
        __typename?: 'Company';
        id?: string | null;
        name: string;
        domain?: string | null;
        logoLink?: string | null;
      };
      endAt?: { __typename?: 'MonthYear'; year: number } | null;
    }> | null;
    availability?: {
      __typename?: 'CoachAvailability';
      nextAvailableAt?: number | null;
    } | null;
  } | null;
};

export type OfferingPackagePageSearchCoachesQueryVariables = Types.Exact<{
  categoryUrn?: Types.InputMaybe<Types.Scalars['CategoryUrn']['input']>;
  skuTiers?: Types.InputMaybe<Array<Types.SkuTier> | Types.SkuTier>;
  count: Types.Scalars['Int']['input'];
}>;

export type OfferingPackagePageSearchCoachesQuery = {
  __typename?: 'Query';
  searchCoaches: {
    __typename?: 'CoachSearchResponse';
    total: number;
    results: Array<{
      __typename?: 'Coach';
      id: string;
      slug: string;
      tier: Types.SkuTier;
      bio?: string | null;
      hourlyRate?: number | null;
      reviewTotal: number;
      averageReviewRate: number;
      user: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        pictureLink?: string | null;
      };
      categoryInformationList?: Array<{
        __typename?: 'CategoryInformation';
        headline?: string | null;
        category: {
          __typename?: 'Category';
          id: string;
          goal: Types.GoalName;
          sortRank?: number | null;
          slug: string;
        };
      }> | null;
      educationExperiences?: Array<{
        __typename?: 'Education';
        admissionCommittee: boolean;
        isFeatured?: boolean | null;
        school: {
          __typename?: 'School';
          id: string;
          name: string;
          logoLink?: string | null;
        };
      }> | null;
      professionalExperiences?: Array<{
        __typename?: 'ProfessionalExperience';
        experienceType?: Types.ExperienceType | null;
        isFeatured?: boolean | null;
        company: {
          __typename?: 'Company';
          id?: string | null;
          name: string;
          domain?: string | null;
          logoLink?: string | null;
        };
        endAt?: { __typename?: 'MonthYear'; year: number } | null;
      }> | null;
      availability?: {
        __typename?: 'CoachAvailability';
        nextAvailableAt?: number | null;
      } | null;
    }>;
  };
};

export const OfferingPackagePageOfferingPackagePriceFragmentDoc = gql`
  fragment OfferingPackagePage_OfferingPackagePrice on OfferingPackagePrice {
    tier
    sku
    ...SelectAPackageSizeModal_OfferingPackagePrice
  }
  ${SelectAPackageSizeModalOfferingPackagePriceFragmentDoc}
`;
export const OfferingPackagePageOfferingPackageFragmentDoc = gql`
  fragment OfferingPackagePage_OfferingPackage on OfferingPackage {
    id
    name
    description
    imageLink
    coachingFocusList {
      id
      name
    }
    deliveryFormat
    coachingDescription
    deliverables
    category {
      id
      slug
      ...OfferingPackageCoachAbout_Category
      ...PackageReviews_Category
    }
    packageTerm {
      refundPolicy
      additionalInformation
    }
    coach {
      id
      user {
        id
        firstName
      }
      categoryInformationList(showHidden: false) {
        category {
          id
        }
        coachingFocusList {
          ...CoachOfferings_CoachingFocus
        }
      }
      coachingRelationship {
        id
        blockedByCoach
      }
      visibility
      ...IntroVideo_Coach
      ...ReviewSlider_Coach
      ...AllCoachReviewsModal_Coach
      ...MessageModal_Coach
      ...OfferingPackageCoachAbout_Coach
      ...OfferingPackageCoachMessagePrompt_Coach
      ...CoachOfferings_Coach
    }
    subCategories {
      id
    }
    ...OfferingPackageImage_OfferingPackage
    ...OfferingPackageBanner_OfferingPackage
    ...OfferingPackagePricingInfo_OfferingPackage
    ...OfferingPackageBottomCTA_OfferingPackage
    ...OfferingPackageCard_OfferingPackage
    prices {
      ...OfferingPackagePage_OfferingPackagePrice
      freeLelandPlusPeriod {
        amount
        unit
      }
    }
    isUniversalPackage
  }
  ${OfferingPackageCoachAboutCategoryFragmentDoc}
  ${PackageReviewsCategoryFragmentDoc}
  ${CoachOfferingsCoachingFocusFragmentDoc}
  ${IntroVideoCoachFragmentDoc}
  ${ReviewSliderCoachFragmentDoc}
  ${AllCoachReviewsModalCoachFragmentDoc}
  ${MessageModalCoachFragmentDoc}
  ${OfferingPackageCoachAboutCoachFragmentDoc}
  ${OfferingPackageCoachMessagePromptCoachFragmentDoc}
  ${CoachOfferingsCoachFragmentDoc}
  ${OfferingPackageImageOfferingPackageFragmentDoc}
  ${OfferingPackageBannerOfferingPackageFragmentDoc}
  ${OfferingPackagePricingInfoOfferingPackageFragmentDoc}
  ${OfferingPackageBottomCtaOfferingPackageFragmentDoc}
  ${OfferingPackageCardOfferingPackageFragmentDoc}
  ${OfferingPackagePageOfferingPackagePriceFragmentDoc}
`;
export const OfferingPackagePageCoachPackageFragmentDoc = gql`
  fragment OfferingPackagePage_CoachPackage on OfferingPackage {
    id
    status
    ...CoachOfferings_OfferingPackage
  }
  ${CoachOfferingsOfferingPackageFragmentDoc}
`;
export const OfferingPackagePageOpportunityCoachFragmentDoc = gql`
  fragment OfferingPackagePage_OpportunityCoach on Coach {
    ...OfferingPackagePricingInfo_OpportunityCoach
  }
  ${OfferingPackagePricingInfoOpportunityCoachFragmentDoc}
`;
export const OfferingPackagePageCreateOrderDocument = gql`
  mutation OfferingPackagePage_CreateOrder(
    $coachUrn: CoachUrn!
    $packageOrder: PackageOrderInput!
    $numberOfCharges: Int!
    $tier: SkuTier
  ) {
    createOrder(
      coachUrn: $coachUrn
      packageOrder: $packageOrder
      numberOfCharges: $numberOfCharges
      tier: $tier
    ) {
      id
    }
  }
`;
export type OfferingPackagePageCreateOrderMutationFn = Apollo.MutationFunction<
  OfferingPackagePageCreateOrderMutation,
  OfferingPackagePageCreateOrderMutationVariables
>;

/**
 * __useOfferingPackagePageCreateOrderMutation__
 *
 * To run a mutation, you first call `useOfferingPackagePageCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagePageCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offeringPackagePageCreateOrderMutation, { data, loading, error }] = useOfferingPackagePageCreateOrderMutation({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      packageOrder: // value for 'packageOrder'
 *      numberOfCharges: // value for 'numberOfCharges'
 *      tier: // value for 'tier'
 *   },
 * });
 */
export function useOfferingPackagePageCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OfferingPackagePageCreateOrderMutation,
    OfferingPackagePageCreateOrderMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    OfferingPackagePageCreateOrderMutation,
    OfferingPackagePageCreateOrderMutationVariables
  >(OfferingPackagePageCreateOrderDocument, options);
}
export type OfferingPackagePageCreateOrderMutationHookResult = ReturnType<
  typeof useOfferingPackagePageCreateOrderMutation
>;
export type OfferingPackagePageCreateOrderMutationResult =
  Apollo.MutationResult<OfferingPackagePageCreateOrderMutation>;
export type OfferingPackagePageCreateOrderMutationOptions =
  Apollo.BaseMutationOptions<
    OfferingPackagePageCreateOrderMutation,
    OfferingPackagePageCreateOrderMutationVariables
  >;
export const OfferingPackagePageGetRelationshipDocument = gql`
  query OfferingPackagePage_GetRelationship($coachUrn: CoachUrn!) {
    coach(id: $coachUrn) {
      id
      coachingRelationship {
        id
      }
    }
  }
`;

/**
 * __useOfferingPackagePageGetRelationshipQuery__
 *
 * To run a query within a React component, call `useOfferingPackagePageGetRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagePageGetRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagePageGetRelationshipQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *   },
 * });
 */
export function useOfferingPackagePageGetRelationshipQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagePageGetRelationshipQuery,
    OfferingPackagePageGetRelationshipQueryVariables
  > &
    (
      | {
          variables: OfferingPackagePageGetRelationshipQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagePageGetRelationshipQuery,
    OfferingPackagePageGetRelationshipQueryVariables
  >(OfferingPackagePageGetRelationshipDocument, options);
}
export function useOfferingPackagePageGetRelationshipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagePageGetRelationshipQuery,
    OfferingPackagePageGetRelationshipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagePageGetRelationshipQuery,
    OfferingPackagePageGetRelationshipQueryVariables
  >(OfferingPackagePageGetRelationshipDocument, options);
}
export function useOfferingPackagePageGetRelationshipSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingPackagePageGetRelationshipQuery,
    OfferingPackagePageGetRelationshipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagePageGetRelationshipQuery,
    OfferingPackagePageGetRelationshipQueryVariables
  >(OfferingPackagePageGetRelationshipDocument, options);
}
export type OfferingPackagePageGetRelationshipQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetRelationshipQuery
>;
export type OfferingPackagePageGetRelationshipLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetRelationshipLazyQuery
>;
export type OfferingPackagePageGetRelationshipSuspenseQueryHookResult =
  ReturnType<typeof useOfferingPackagePageGetRelationshipSuspenseQuery>;
export type OfferingPackagePageGetRelationshipQueryResult = Apollo.QueryResult<
  OfferingPackagePageGetRelationshipQuery,
  OfferingPackagePageGetRelationshipQueryVariables
>;
export const OfferingPackagePageGetHourlyOrderDocument = gql`
  query OfferingPackagePage_GetHourlyOrder($id: OrderUrn!) {
    order(id: $id) {
      id
      hourlyOrder {
        timeInMinute
      }
    }
  }
`;

/**
 * __useOfferingPackagePageGetHourlyOrderQuery__
 *
 * To run a query within a React component, call `useOfferingPackagePageGetHourlyOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagePageGetHourlyOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagePageGetHourlyOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfferingPackagePageGetHourlyOrderQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagePageGetHourlyOrderQuery,
    OfferingPackagePageGetHourlyOrderQueryVariables
  > &
    (
      | {
          variables: OfferingPackagePageGetHourlyOrderQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagePageGetHourlyOrderQuery,
    OfferingPackagePageGetHourlyOrderQueryVariables
  >(OfferingPackagePageGetHourlyOrderDocument, options);
}
export function useOfferingPackagePageGetHourlyOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagePageGetHourlyOrderQuery,
    OfferingPackagePageGetHourlyOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagePageGetHourlyOrderQuery,
    OfferingPackagePageGetHourlyOrderQueryVariables
  >(OfferingPackagePageGetHourlyOrderDocument, options);
}
export function useOfferingPackagePageGetHourlyOrderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingPackagePageGetHourlyOrderQuery,
    OfferingPackagePageGetHourlyOrderQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagePageGetHourlyOrderQuery,
    OfferingPackagePageGetHourlyOrderQueryVariables
  >(OfferingPackagePageGetHourlyOrderDocument, options);
}
export type OfferingPackagePageGetHourlyOrderQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetHourlyOrderQuery
>;
export type OfferingPackagePageGetHourlyOrderLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetHourlyOrderLazyQuery
>;
export type OfferingPackagePageGetHourlyOrderSuspenseQueryHookResult =
  ReturnType<typeof useOfferingPackagePageGetHourlyOrderSuspenseQuery>;
export type OfferingPackagePageGetHourlyOrderQueryResult = Apollo.QueryResult<
  OfferingPackagePageGetHourlyOrderQuery,
  OfferingPackagePageGetHourlyOrderQueryVariables
>;
export const OfferingPackagePageSearchPackagesDocument = gql`
  query OfferingPackagePage_SearchPackages(
    $keyword: String
    $categoryUrn: CategoryUrn!
    $subCategoryUrns: [SubCategoryUrn!]
    $coachingFocusListFilter: [CoachingFocusUrn!]
    $priceFilter: IntRangeInput
    $start: Int!
    $count: Int!
    $idsToExclude: [PackageUrn!]
  ) {
    searchPackages(
      keyword: $keyword
      categoryUrn: $categoryUrn
      subCategoriesFilter: $subCategoryUrns
      coachingFocusListFilter: $coachingFocusListFilter
      priceFilter: $priceFilter
      start: $start
      count: $count
      idsToExclude: $idsToExclude
    ) {
      results {
        id
        ...OfferingPackages_OfferingPackage
      }
      total
    }
  }
  ${OfferingPackagesOfferingPackageFragmentDoc}
`;

/**
 * __useOfferingPackagePageSearchPackagesQuery__
 *
 * To run a query within a React component, call `useOfferingPackagePageSearchPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagePageSearchPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagePageSearchPackagesQuery({
 *   variables: {
 *      keyword: // value for 'keyword'
 *      categoryUrn: // value for 'categoryUrn'
 *      subCategoryUrns: // value for 'subCategoryUrns'
 *      coachingFocusListFilter: // value for 'coachingFocusListFilter'
 *      priceFilter: // value for 'priceFilter'
 *      start: // value for 'start'
 *      count: // value for 'count'
 *      idsToExclude: // value for 'idsToExclude'
 *   },
 * });
 */
export function useOfferingPackagePageSearchPackagesQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagePageSearchPackagesQuery,
    OfferingPackagePageSearchPackagesQueryVariables
  > &
    (
      | {
          variables: OfferingPackagePageSearchPackagesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagePageSearchPackagesQuery,
    OfferingPackagePageSearchPackagesQueryVariables
  >(OfferingPackagePageSearchPackagesDocument, options);
}
export function useOfferingPackagePageSearchPackagesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagePageSearchPackagesQuery,
    OfferingPackagePageSearchPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagePageSearchPackagesQuery,
    OfferingPackagePageSearchPackagesQueryVariables
  >(OfferingPackagePageSearchPackagesDocument, options);
}
export function useOfferingPackagePageSearchPackagesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingPackagePageSearchPackagesQuery,
    OfferingPackagePageSearchPackagesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagePageSearchPackagesQuery,
    OfferingPackagePageSearchPackagesQueryVariables
  >(OfferingPackagePageSearchPackagesDocument, options);
}
export type OfferingPackagePageSearchPackagesQueryHookResult = ReturnType<
  typeof useOfferingPackagePageSearchPackagesQuery
>;
export type OfferingPackagePageSearchPackagesLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagePageSearchPackagesLazyQuery
>;
export type OfferingPackagePageSearchPackagesSuspenseQueryHookResult =
  ReturnType<typeof useOfferingPackagePageSearchPackagesSuspenseQuery>;
export type OfferingPackagePageSearchPackagesQueryResult = Apollo.QueryResult<
  OfferingPackagePageSearchPackagesQuery,
  OfferingPackagePageSearchPackagesQueryVariables
>;
export const OfferingPackagePageGetCoachDocument = gql`
  query OfferingPackagePage_GetCoach($id: CoachUrn!) {
    coach(id: $id) {
      ...OfferingPackagePage_OpportunityCoach
    }
  }
  ${OfferingPackagePageOpportunityCoachFragmentDoc}
`;

/**
 * __useOfferingPackagePageGetCoachQuery__
 *
 * To run a query within a React component, call `useOfferingPackagePageGetCoachQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagePageGetCoachQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagePageGetCoachQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfferingPackagePageGetCoachQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagePageGetCoachQuery,
    OfferingPackagePageGetCoachQueryVariables
  > &
    (
      | { variables: OfferingPackagePageGetCoachQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagePageGetCoachQuery,
    OfferingPackagePageGetCoachQueryVariables
  >(OfferingPackagePageGetCoachDocument, options);
}
export function useOfferingPackagePageGetCoachLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagePageGetCoachQuery,
    OfferingPackagePageGetCoachQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagePageGetCoachQuery,
    OfferingPackagePageGetCoachQueryVariables
  >(OfferingPackagePageGetCoachDocument, options);
}
export function useOfferingPackagePageGetCoachSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingPackagePageGetCoachQuery,
    OfferingPackagePageGetCoachQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagePageGetCoachQuery,
    OfferingPackagePageGetCoachQueryVariables
  >(OfferingPackagePageGetCoachDocument, options);
}
export type OfferingPackagePageGetCoachQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetCoachQuery
>;
export type OfferingPackagePageGetCoachLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetCoachLazyQuery
>;
export type OfferingPackagePageGetCoachSuspenseQueryHookResult = ReturnType<
  typeof useOfferingPackagePageGetCoachSuspenseQuery
>;
export type OfferingPackagePageGetCoachQueryResult = Apollo.QueryResult<
  OfferingPackagePageGetCoachQuery,
  OfferingPackagePageGetCoachQueryVariables
>;
export const OfferingPackagePageSearchCoachesDocument = gql`
  query OfferingPackagePage_SearchCoaches(
    $categoryUrn: CategoryUrn
    $skuTiers: [SkuTier!]
    $count: Int!
  ) {
    searchCoaches(
      categoryUrn: $categoryUrn
      skuTiers: $skuTiers
      count: $count
    ) {
      results {
        ...VerticalCoachCard_Coach
      }
      total
    }
  }
  ${VerticalCoachCardCoachFragmentDoc}
`;

/**
 * __useOfferingPackagePageSearchCoachesQuery__
 *
 * To run a query within a React component, call `useOfferingPackagePageSearchCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferingPackagePageSearchCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferingPackagePageSearchCoachesQuery({
 *   variables: {
 *      categoryUrn: // value for 'categoryUrn'
 *      skuTiers: // value for 'skuTiers'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useOfferingPackagePageSearchCoachesQuery(
  baseOptions: Apollo.QueryHookOptions<
    OfferingPackagePageSearchCoachesQuery,
    OfferingPackagePageSearchCoachesQueryVariables
  > &
    (
      | {
          variables: OfferingPackagePageSearchCoachesQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OfferingPackagePageSearchCoachesQuery,
    OfferingPackagePageSearchCoachesQueryVariables
  >(OfferingPackagePageSearchCoachesDocument, options);
}
export function useOfferingPackagePageSearchCoachesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OfferingPackagePageSearchCoachesQuery,
    OfferingPackagePageSearchCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OfferingPackagePageSearchCoachesQuery,
    OfferingPackagePageSearchCoachesQueryVariables
  >(OfferingPackagePageSearchCoachesDocument, options);
}
export function useOfferingPackagePageSearchCoachesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OfferingPackagePageSearchCoachesQuery,
    OfferingPackagePageSearchCoachesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OfferingPackagePageSearchCoachesQuery,
    OfferingPackagePageSearchCoachesQueryVariables
  >(OfferingPackagePageSearchCoachesDocument, options);
}
export type OfferingPackagePageSearchCoachesQueryHookResult = ReturnType<
  typeof useOfferingPackagePageSearchCoachesQuery
>;
export type OfferingPackagePageSearchCoachesLazyQueryHookResult = ReturnType<
  typeof useOfferingPackagePageSearchCoachesLazyQuery
>;
export type OfferingPackagePageSearchCoachesSuspenseQueryHookResult =
  ReturnType<typeof useOfferingPackagePageSearchCoachesSuspenseQuery>;
export type OfferingPackagePageSearchCoachesQueryResult = Apollo.QueryResult<
  OfferingPackagePageSearchCoachesQuery,
  OfferingPackagePageSearchCoachesQueryVariables
>;
